import ContentSectionTabs from './contentSectionTabs';

export default ContentSectionTabs;
